(function () {
  /* 
    该js可以动态的计算页面的HTML的字体大小
    可以进行等比缩放的效果
  */
  var 
    resizeEvent = "onorientationchange" in window ? 'orientationchange' : 'resize', // pc还是移动
    doc = document.documentElement, // html
    resize = function () {
      // 获取视口宽度
      var WIDTH = doc.clientWidth > 750 ? 750 : doc.clientWidth
      // 动态计算字体大小
      // 100是因为方便口算  750因为设计图宽度是750px
      doc.style.fontSize = 100 * WIDTH / 750 + 'px'
    }

  // 绑定事件
  // 1 页面加载完成后
  window.addEventListener('DOMContentLoaded', resize, false)
  // 2 页面resize事件
  window.addEventListener(resizeEvent, resize)
}())
  






